export const MEMBER_DASHBOARD_FOUNDER_WELCOME_VIDEO_ID =
  "member_dashboard_founder_welcome_v1";

export const MEMBER_DASHBOARD_FOUNDER_WELCOME_VIDEO_URL =
  "https://firebasestorage.googleapis.com/v0/b/ourlinkedlives.appspot.com/o/growth%2Fpre-onboarding%2Ffounder-welcome-v1%2Ffounder-welcome.mp4?alt=media&token=b2da38d4-2a65-476f-be53-2d74a36884c2";

export const MEMBER_DASHBOARD_FOUNDER_WELCOME_POSTER_URL =
  "https://firebasestorage.googleapis.com/v0/b/ourlinkedlives.appspot.com/o/growth%2Fpre-onboarding%2Ffounder-welcome-v1%2Ffounder-welcome-poster.jpg?alt=media&token=9061c52c-0f3f-42b7-972e-e1a59110af58";

export const MEMBER_DASHBOARD_FOUNDER_WELCOME_STORAGE_PATH =
  "growth/pre-onboarding/founder-welcome-v1/founder-welcome.mp4";

export const MEMBER_DASHBOARD_FOUNDER_WELCOME_POSTER_STORAGE_PATH =
  "growth/pre-onboarding/founder-welcome-v1/founder-welcome-poster.jpg";
